<div class="p-4">
    <h2 class="text-xl font-bold mb-4">Bill of Materials (BOM)</h2>
  
    <!-- Table -->
    <table class="min-w-full border border-gray-300 rounded-lg">
      <thead class="bg-gray-200">
        <tr>
          <th class="px-4 py-2 border">#</th>
          <th class="px-4 py-2 border">Material Name</th>
          <th class="px-4 py-2 border">Quantity</th>
          <th class="px-4 py-2 border">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of bomList; let i = index" class="hover:bg-gray-50">
          <td class="px-4 py-2 border">{{ i + 1 }}</td>
          <td class="px-4 py-2 border">{{ item.name }}</td>
          <td class="px-4 py-2 border">{{ item.quantity }}</td>
          <td class="px-4 py-2 border text-center">
            <button (click)="editItem(item)" class="bg-blue-500 text-white px-3 py-1 rounded mr-2">
              Edit
            </button>
            <button (click)="deleteItem(item)" class="bg-red-500 text-white px-3 py-1 rounded">
              Delete
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  
    <!-- Update Form -->
    <div *ngIf="selectedItem" class="mt-6 border p-4 rounded-lg bg-gray-50">
      <h3 class="text-lg font-semibold mb-2">Update BOM Item</h3>
      <form (ngSubmit)="updateItem()">
        <div class="mb-3">
          <label class="block font-medium mb-1">Material Name</label>
          <input
            type="text"
            [(ngModel)]="selectedItem.name"
            name="name"
            class="w-full border px-3 py-2 rounded"
            required
          />
        </div>
        <div class="mb-3">
          <label class="block font-medium mb-1">Quantity</label>
          <input
            type="number"
            [(ngModel)]="selectedItem.quantity"
            name="quantity"
            class="w-full border px-3 py-2 rounded"
            required
          />
        </div>
        <div class="flex gap-3">
          <button type="submit" class="bg-green-600 text-white px-4 py-2 rounded">
            Update
          </button>
          <button type="button" (click)="cancelEdit()" class="bg-gray-500 text-white px-4 py-2 rounded">
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
  